import { Hero } from '@/components/Hero'
import { WhatIsEvtimia } from '@/components/WhatIsEvtimia'
import { SocialProof } from '@/components/SocialProof'
import { ClosingCta } from '@/components/ClosingCta'
export default function HomePage() {
  return (
    <>
      <Hero />
      <WhatIsEvtimia />
      <SocialProof />
      <ClosingCta />
    </>
  )
}
